import { useState, useEffect } from 'react'
import RarityService from '../services/rarityService.js'

export const useRarities = () => {
  const [rarities, setRarities] = useState([])
  const [raritiesMap, setRaritiesMap] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadRarities()
  }, [])

  const loadRarities = async () => {
    try {
      setLoading(true)
      setError(null)

      // Cargar tanto la lista como el mapa de rarezas
      const [raritiesResponse, mapResponse] = await Promise.all([RarityService.getAllRarities(), RarityService.getRaritiesMap()])

      setRarities(raritiesResponse.data)
      setRaritiesMap(mapResponse.data)
    } catch (err) {
      console.error('Error al cargar rarezas:', err)
      setError(err.message || 'Error al cargar rarezas')

      // Fallback a rarezas hardcodeadas en caso de error
      const fallbackRarities = {
        common: {
          name: 'common',
          display_name: 'Común',
          color: '#9c6639',
          order_priority: 1,
          has_glow: false,
        },
        uncommon: {
          name: 'uncommon',
          display_name: 'Poco Común',
          color: '#1a9658',
          order_priority: 2,
          has_glow: false,
        },
        rare: {
          name: 'rare',
          display_name: 'Raro',
          color: '#3b82c4',
          order_priority: 3,
          has_glow: false,
        },
        epic: {
          name: 'epic',
          display_name: 'Épico',
          color: '#9333ea',
          order_priority: 4,
          has_glow: false,
        },
        legendary: {
          name: 'legendary',
          display_name: 'Legendario',
          color: '#f59e0b',
          order_priority: 5,
          has_glow: true,
        },
      }

      setRaritiesMap(fallbackRarities)
      setRarities(Object.values(fallbackRarities))
    } finally {
      setLoading(false)
    }
  }

  const getRarityColor = (rarityName) => {
    return raritiesMap[rarityName]?.color || '#9c6639'
  }

  const getRarityDisplayName = (rarityName) => {
    return raritiesMap[rarityName]?.display_name || 'Común'
  }

  const getRarityHasGlow = (rarityName) => {
    return raritiesMap[rarityName]?.has_glow || false
  }

  const getRarityByName = (rarityName) => {
    return raritiesMap[rarityName] || null
  }

  return {
    rarities,
    raritiesMap,
    loading,
    error,
    getRarityColor,
    getRarityDisplayName,
    getRarityHasGlow,
    getRarityByName,
    reloadRarities: loadRarities,
  }
}
